import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFileWord as farFileWord,
  faFilePowerpoint as farFilePowerpoint,
  faFileExcel as farFileExcel,
  faFilePdf as farFilePdf,
  faFileVideo as farFileVideo,
  faFileAudio as farFileAudio,
  faFileCode as farFileCode,
  faFileLock as farFileLock,
  faFileShield as farFileShield,
  faFileCircleExclamation as farFileCircleExclamation,
  faFileImage as farFileImage,
  faFileArchive as farFileArchive,
  faEnvelope as farEnvelope,
  faFile as farFile,
  faXmarkCircle as farXmarkCircle,
  faCopy as farCopy,
  faFileExport as farFileExport,
  faFilePen as farFilePen,
  faTrash as farTrash,
  faShare as farShare,
  faEyeSlash as farEyeSlash,
  faFilePlus as farFilePlus,
  faFileImport as farFileImport,
  faFileUpload as farFileUpload,
  faPenToSquare as farPenToSquare,
  faClone as farClone,
  faSearch as farSearch,
  faArrowUpRightFromSquare as farArrowUpRightFromSquare,
  faDownload as farDownload,
  faUserXmark as farUserXmark,
  faArrowLeftToLine as farArrowLeftToLine,
  faDoNotEnter as farDoNotEnter,
  faCheck as farCheck,
  faClockRotateLeft as faClockRotateLeft,
  faClockEight as farClockEight,
  faMagnifyingGlass as farMagnifyingGlass,
  faXmark as farXmark,
  faEye as fasEye,
  faBoxArrowUp as farBoxArrowUp,
  faArrowRightArrowLeft as farArrowRightArrowLeft,
  faArrowsUpDownLeftRight as farArrowsUpDownLeftRight,
  faBriefcaseArrowRight as farBriefcaseArrowRight
} from "@fortawesome/pro-regular-svg-icons";

import {
  faFolder as fasFolder,
  faFolderPlus as fasFolderPlus,
  faDatabase as fasDatabase,
  faUsers as fasUsers,
  faSearch as fasSearch,
  faAngleLeft as fasAngleLeft,
  faAngleRight as fasAngleRight,
  faAngleDown as fasAngleDown,
  faCheck as fasCheck,
  faFileArchive as fasFileArchive,
  faLink as fasLink,
  faPlus as fasPlus,
  faCircleInfo as fasCircleInfo,
  faWrench as fasWrench,
  faBarsStaggered as fasBarsStaggered,
  faTableCells as fasTableCells,
  faBars as fasBars,
  faLock as fasLock,
  faXmark as fasXmark,
  faJ as fasJ,
  faTrash as fasTrash,
  faLockKeyholeOpen as fasLockKeyholeOpen,
  faLockKeyhole as fasLockKeyhole,
  faFile as fasFile,
  faFileCheck as fasFileCheck,
  faBold as fasBold,
  faItalic as fasItalic,
  faUnderline as fasUnderline,
  faListUl as fasListUl,
  faListOl as fasListOl,
  faH1 as fasH1,
  faH2 as fasH2,
  faH3 as fasH3,
  faH4 as fasH4,
  faCode as fasCode,
  faParagraph as fasParagraph,
  faRotateLeft as fasRotateLeft,
  faRotateRight as fasRotateRight
} from "@fortawesome/pro-solid-svg-icons";

import {
  faFilePlus as falFilePlus,
  faFileImport as falFileImport,
  faFileUpload as falFileUpload,
  faCopy as falCopy,
  faFileExport as falFileExport,
  faFilePen as falFilePen,
  faTrash as falTrash,
  faShare as falShare,
  faEyeSlash as falEyeSlash,
  faXmark as falXmark,
  faSearch as falSearch,
  faFaceSadTear as falFaceSadTear,
  faEllipsisVertical as falEllipsisVertical,
  faPenToSquare as falPenToSquare
} from "@fortawesome/pro-light-svg-icons";

import {
  faAndroid as fabAndroid,
  faChrome as fabChrome,
  faApple as fabApple,
  faEdge as fabEdge,
  faWindows as fabWindows
} from "@fortawesome/free-brands-svg-icons";

export default {
  initFontAwesome() {
    // Regular
    library.add(
      farEyeSlash,
      farFileWord,
      farFilePowerpoint,
      farFileExcel,
      farFilePdf,
      farFileVideo,
      farFileAudio,
      farFileCode,
      farFileLock,
      farFileShield,
      farFileCircleExclamation,
      farFileImage,
      farFileArchive,
      farEnvelope,
      farFile,
      farXmarkCircle,
      farCopy,
      farFileExport,
      farFilePen,
      farTrash,
      farShare,
      farFilePlus,
      farFileImport,
      farFileUpload,
      farPenToSquare,
      farClone,
      farSearch,
      farArrowUpRightFromSquare,
      farDownload,
      farUserXmark,
      farArrowLeftToLine,
      farDoNotEnter,
      farCheck,
      faClockRotateLeft,
      farClockEight,
      farMagnifyingGlass,
      farXmark,
      farBoxArrowUp,
      farArrowRightArrowLeft,
      farArrowsUpDownLeftRight,
      farBriefcaseArrowRight
    );

    // Solid
    library.add(
      fasFolder,
      fasFolderPlus,
      fasDatabase,
      fasUsers,
      fasSearch,
      fasAngleLeft,
      fasAngleRight,
      fasAngleDown,
      fasCheck,
      fasFileArchive,
      fasLink,
      fasPlus,
      fasCircleInfo,
      fasWrench,
      fasBarsStaggered,
      fasTableCells,
      fasBars,
      fasLock,
      fasXmark,
      fasJ,
      fasTrash,
      fasLockKeyholeOpen,
      fasLockKeyhole,
      fasFile,
      fasFileCheck,
      fasEye,
      fasBold,
      fasItalic,
      fasUnderline,
      fasListUl,
      fasListOl,
      fasH1,
      fasH2,
      fasH3,
      fasH4,
      fasCode,
      fasParagraph,
      fasLink,
      fasRotateLeft,
      fasRotateRight
    );

    // Light
    library.add(
      falFilePlus,
      falFileImport,
      falFileUpload,
      falCopy,
      falFileExport,
      falFilePen,
      falTrash,
      falShare,
      falEyeSlash,
      falXmark,
      falSearch,
      falFaceSadTear,
      falEllipsisVertical,
      falPenToSquare
    );

    library.add(fabAndroid, fabChrome, fabApple, fabEdge, fabWindows);
  }
};
